export default {
    selected_order: "주문:",
    selected_worker: "라이더:",
    cancel_selected: "선택 취소({0})",
    request_worker: "배차요청 {0}건 ({1})",
    allocate: "즉시배차 {0}건 ({1})",
    reallocate: "@:{'common.reallocated'} {0}건 ({1})",
    confirm_reallocate: "선택한 주문을 <span class='worker-name'>{0}</span>라이더에게 재배차 하시겠습니까?",
    succeeded_allocate: "배차 성공했습니다.",
    succeeded_reallocate: "재배차 성공했습니다.",
    impossible_request: "단건, 묶음 주문은 한 건씩만 즉시배차/배차요청 가능합니다.",
};
